import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentCoreExpertiseValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value?.trim().replace(/\s+/g, ' ');

		if (!value) {
			return null;
		}

		if (value.length < 2) {
			return { minLengthCoreExpertise: true };
		}

		if (value.length > 200) {
			return { maxLengthCoreExpertise: true };
		}

		const pattern = /^[A-Za-z0-9\s,\-.&+#]+$/;

		if (!pattern.test(value)) {
			return { invalidCoreExpertise: true };
		}

		return null;
	};
}